

<template>
    <vx-card class="limited-max-width" id="ss-eighth-step">
        <div>
            <header-step-process-component
                v-bind:step="step">
            </header-step-process-component>

            <span class="title-style modify-title" style="display:inline-block; margin-bottom:8px">Cuestionario de salud</span>
            <!-- <h1>Cuestionario de salud</h1> -->
            <forms-repository
                v-bind:code="code"
                v-bind:next="next"
                v-bind:previus="previus"

                v-bind:formFilter="formFilter"
            >
            </forms-repository>
        </div>
    </vx-card>

</template>
<script>
import VxCard from '../../components/vx-card/VxCard.vue'
import HeaderStepProcessComponent from '../components/eprevision-components/header/HeaderStepProcessComponent.vue'
import FormsRepository from '../forms/e-prevision-forms/forms-repository.vue'
/* eslint-disable */ 
export default {
  components: { VxCard, HeaderStepProcessComponent, FormsRepository },
   data() {
      return {
            step: 5,
            code: this.$route.params.code,
            next: "social-security/ninth",
            previus: "social-security/seventh",

            formFilter: "healthQuestionnaireForm",

      }
  },
  created() {
      this.$vs.loading.close()
  },
  methods: {
  }
    
}
</script>

<style lang="scss">

</style>